var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60875 0C1.91687 0 1.25332 0.27485 0.764086 0.764086C0.27485 1.25332 0 1.91687 0 2.60875L0 13.0438C0 13.7356 0.27485 14.3992 0.764086 14.8884C1.25332 15.3777 1.91687 15.6525 2.60875 15.6525H5.86969C6.07219 15.6525 6.27191 15.6997 6.45303 15.7902C6.63415 15.8808 6.7917 16.0123 6.91319 16.1743L9.39151 19.4782C9.51301 19.6402 9.67055 19.7717 9.85167 19.8623C10.0328 19.9529 10.2325 20 10.435 20C10.6375 20 10.8372 19.9529 11.0183 19.8623C11.1995 19.7717 11.357 19.6402 11.4785 19.4782L13.9568 16.1743C14.0783 16.0123 14.2359 15.8808 14.417 15.7902C14.5981 15.6997 14.7978 15.6525 15.0003 15.6525H18.2613C18.9531 15.6525 19.6167 15.3777 20.1059 14.8884C20.5952 14.3992 20.87 13.7356 20.87 13.0438V2.60875C20.87 1.91687 20.5952 1.25332 20.1059 0.764086C19.6167 0.27485 18.9531 0 18.2613 0L2.60875 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.b3fc8f7435c7aae2bbcdda0abf8da0dd.svg";
export { ForwardRef as ReactComponent };